<template>
  <el-form
    label-position="top"
    :model="price"
    :rules="rules"
    ref="priceForm"
    v-loading="formLoading"
  >
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          label="Termék"
          prop="product"
        >
          <el-select
            v-model="price.product"
            style="width: 100%;"
            value-key="id"
            @change="price.product_id = price.product.id"
          >
            <el-option
              v-for="product in products"
              :value="product"
              :label="product.name"
              :key="product.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Típus"
          prop="price_type"
        >
          <el-select
            v-model="price.price_type"
            style="width: 100%;"
            value-key="id"
            @change="price.price_type_id = price.price_type.id"
          >
            <el-option
              v-for="priceType in priceTypes"
              :value="priceType"
              :label="priceType.name"
              :key="priceType.id"
            />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-form-item
          label="Ár"
          prop="price"
        >
          <el-input
            v-model="price.price"
          >
            <template slot="append">
              Ft
            </template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item
          prop="valid_from"
          label="Érvényesség kezdete"
        >
          <el-date-picker
            v-model="price.valid_from"
            type="datetime"
            style="width: 100%;"
            :clearable="false"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item
          prop="valid_from"
          label="Érvényesség vége"
        >
          <el-date-picker
            v-model="price.valid_to"
            type="datetime"
            style="width: 100%;"
            :clearable="false"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
  export default {
    props: ['defaultPrice', 'formType'],
    data() {
      return {
        price: {
          valid_from: null,
          valid_to: null
        },
        products: [],
        formLoading: false,
        rules: {
          price_type: [
            { required: true, message: 'Típus megadása kötelező', trigger: 'change' }
          ],
          product: [
            { required: true, message: 'Termék megadása kötelező', trigger: 'change' }
          ],
          price: [
            { required: true, message: 'Ár megadása kötelező', trigger: 'change' }
          ],
        }
      };
    },
    computed: {
      priceTypes() {
        return this.$store.getters['priceType/priceTypes'];
      }
    },
    watch: {
      defaultPrice: {
        handler(newVal) {
          this.price = Object.assign({}, newVal);
        },
        deep: true,
      },
    },
    async mounted() {
      this.formLoading = true;
      await this.$store.dispatch('priceType/fetchAll');
      this.products = await this.$store.dispatch('product/search');
      this.price = Object.assign({}, this.defaultPrice);
      this.formLoading = false;
    },
  };
</script>
